"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPositionEnum = void 0;
var CompanyPositionEnum;
(function (CompanyPositionEnum) {
    CompanyPositionEnum["DIRECTOR"] = "DIRECTOR";
    CompanyPositionEnum["AUTHORISED_REPRESENTATIVE"] = "AUTHORISED_REPRESENTATIVE";
})(CompanyPositionEnum || (exports.CompanyPositionEnum = CompanyPositionEnum = {}));
